export default "__VITE_ASSET__Dj3ses0O__"